import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import selector from '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import _Tabs from 'reakit/Tabs';
var TabPanel = styled(_Tabs.Panel).withConfig({
  displayName: "styled__TabPanel",
  componentId: "sc-1783spc-0"
})(["&{", ";}"], theme('fannypack.Tabs.Panel.base'));
var Tab = styled(_Tabs.Tab).withConfig({
  displayName: "styled__Tab",
  componentId: "sc-1783spc-1"
})(["align-items:center;border-top-left-radius:4px;border-top-right-radius:4px;cursor:pointer;display:flex;height:2.5em;justify-content:center;margin-bottom:-1px;padding:0.5rem;&.active{background-color:white;color:", ";fill:", ";", ";}&:focus{outline:none;", ";}&:not(.active):hover{background-color:", ";border-bottom:1px solid ", ";", ";}&:not(:last-child){margin-right:0.5rem;}&{", ";}"], palette('primary'), palette('primary'), theme('fannypack.Tabs.Tab.active'), theme('fannypack.Tabs.Tab.focus'), palette('white700'), palette('textTint'), theme('fannypack.Tabs.Tab.hover'), theme('fannypack.Tabs.Tab.base'));
var alignPropeties = {
  center: css(["justify-content:center;"]),
  right: css(["justify-content:flex-end;"])
};
var Tabs = styled(_Tabs).withConfig({
  displayName: "styled__Tabs",
  componentId: "sc-1783spc-2"
})(["align-items:center;border-bottom:1px solid ", ";display:flex;font-weight:", ";list-style:none;", ";& ", "{", ";", ";}& ", ".active{", ";", ";}&{", ";}&{", ";}"], palette('textTint'), theme('fannypack.fontWeights.semibold'), function (props) {
  return props.isFitted && css(["& ", "{flex:1;}"], selector(Tab));
}, selector(Tab), function (props) {
  return props.type === 'default' && css(["&{", ";}"], theme('fannypack.Tabs.Tab.default.base'));
}, function (props) {
  return props.type === 'boxed' && css(["border:1px solid transparent;&{", ";}"], theme('fannypack.Tabs.Tab.boxed.base'));
}, selector(Tab), function (props) {
  return props.type === 'default' && css(["box-shadow:inset 0 -2px 0 0 ", ";&{", ";}"], palette('primary'), theme('fannypack.Tabs.Tab.default.active'));
}, function (props) {
  return props.type === 'boxed' && css(["border:1px solid ", ";border-bottom-color:transparent;&{", ";}"], palette('textTint'), theme('fannypack.Tabs.Tab.boxed.active'));
}, function (props) {
  return props.align && alignPropeties[props.align || ''];
}, theme('fannypack.Tabs.base'));
export default Tabs;
export { Tab, TabPanel, Tabs };